import { useGetLicense } from "src/hooks/useGetLicense";
import { PersonalSubscription } from "src/components/pages/Home/PersonalSubscription";
import { TeamSubscription } from "src/components/pages/Home/TeamSubscription";
import { LicenseType } from "./license";
import { NoSubscriptions } from "./NoSubscription";
import { ProSubscription } from "./ProSubscription";

export const LicenseContainer = () => {
  const license = useGetLicense();

  if (!license) {
    return <NoSubscriptions />;
  }

  if (license.type === LicenseType.personal) {
    return <PersonalSubscription />;
  }

  if (license.type === LicenseType.team) {
    return <TeamSubscription />;
  }

  return <ProSubscription />;
};
